import type { ReactNode } from 'react';

export const symbol_hand_meal: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M124-509q11-131 103-223.5T450-836v-14q0-13 8.5-21.5T480-880q13 0 21.5 8.5T510-850v14q132 11 224 103.5T837-509h53q13 0 21.5 8.5T920-479q0 13-8.5 21.5T890-449H70q-13 0-21.5-8.5T40-479q0-13 8.5-21.5T70-509h54Zm59 0h594q-11-114-95.5-191.5T480-778q-116 0-201 77.5T183-509Zm297 0Zm91 60H310v270h228q23 0 44-7.5t38-22.5l175-155q-14-12-29-19t-32-9q-17-2-32.5 2.5T672-374l-89 72q-8 7-17.5 10t-20.5 3h-95q-13 0-21.5-8.5T420-319q0-13 8.5-21.5T450-349h96l46-38q10-8 12.5-18t-.5-20q-3-10-11.5-17t-21.5-7Zm-321 0H140v310h110v-310Zm0 370H140q-24 0-42-18t-18-42v-310q0-24 18-42t42-18h431q81 0 154 29t126 89h1q12 14 11 31t-15 29L660-164q-25 22-57 33.5T538-119H306q-7 17-22 28.5T250-79Z"
		/>
	</svg>
);
